export default {
  'form.entityInfo': 'פרטי {{entity}}',
  'form.required': 'שדה {{field}} נדרש',
  'form.inputPlaceholder': 'הזן {{field}}',
  'form.selectPlaceholder': 'בחר {{field}}',
  'form.invalidLayout': 'פריסה לא תואמת',
  'form.cloneFrom': 'שכפל מ־{{instance}}',
  'form.image': 'תמונת {{type}}',
  'form.image.filename': 'שם תמונה',
  'form.image.altText': 'טקסט חלופי לתמונה',
  'form.fullName': 'שם מלא',
  'form.firstName': 'שם פרטי',
  'form.lastName': 'שם משפחה',
  'form.middleName': 'שם אמצעי',
  'form.honorificName': 'תואר',
  'form.birthdate': 'תאריך לידה',
  'form.genderIdentity': 'זהות מגדרית',
  'form.entity': 'ישות',
  'form.entityKey': 'מפתח ישות',
  'form.contentKey': 'מפתח תוכן',
  'form.upload': 'העלאה',
  'form.selectFile': 'בחר קובץ',
  'form.uploadText': 'לחץ או גרור קובץ לאזור זה להעלאה',
  'form.uploadHint':
    'תומך בהעלאה בודדת או מרובה. חל איסור מוחלט להעלות נתוני חברה או קבצי רצועה אחרים',
  'form.uploadTypeError': '{name} אינו סוג קובץ חוקי',
  'form.uploadDimsError':
    'ממדי תמונה מקסימליים (רוחב x גובה) {width}px x {height}px',
  'form.translate': 'תרגם מפתחות',
  'form.helper': 'הצג עזרה',
  'form.license': 'רישיון',
  'form.license.type': 'סוג רישיון',
  'form.license.number': 'מספר רישיון',
  'form.licenses': 'רישיונות',
  'form.title': 'כותרת',
  'form.number': 'מספר',
  'form.description': 'תיאור',
  'form.shortDescription': 'תיאור קצר',
  'form.status': 'סטטוס',
  'form.tags': 'תגיות',
  'form.target': 'יעד',
  'form.link': 'כתובת קישור',
  'form.logo': 'לוגו',
  'form.logos': 'לוגואים',
  'form.logo.primary': 'לוגו ראשי',
  'form.email.type': 'סוג אימייל',
  'form.email': 'כתובת אימייל',
  'form.emails': 'כתובות אימייל',
  'form.countryCode': 'קוד מדינה',
  'form.phone': 'מספר טלפון',
  'form.phones': 'מספרי טלפון',
  'form.phone.type': 'סוג מכשיר',
  'form.phone.businessType': 'עסקי',
  'form.phone.ability': 'סוג טלפון',
  'form.phone.extension': 'שלוחה',
  'form.email.primary': 'אימייל ראשי',
  'form.email.primary.description':
    'ישמש להתראות הקשורות לחשבון ולאיפוס סיסמה.',
  'form.private.helper':
    '{{type}} פרטי לא יכול להיות מוגדר כ־{{type}} ראשי ציבורי במערכת',
  'form.billing.helper':
    '{{type}} פרטי לא יכול להיות מוגדר כ־{{type}} חיוב ציבורי במערכת',
  'form.unverified.helper':
    '{{type}} לא מאומת לא יכול להיות מוגדר כ־{{type}} ראשי ציבורי במערכת',
  'form.phone.primary': 'מספר טלפון ראשי',
  'form.phone.primary.description': 'ישמש לשיחות הקשורות לחשבון.',
  'form.email.exists': 'כתובת האימייל כבר קיימת',
  'form.phone.exists': 'מספר הטלפון כבר קיים',
  'form.preview': 'תצוגה מקדימה',
  'form.documentUrl': 'URL של המסמך',
  'form.imgUrl': 'URL של התמונה',
  'form.embedUrl': 'URL להטמעה',
  'form.ownerName': 'שם בעלים',
  'form.issueDate': 'תאריך הנפקה',
  'form.expirationDate': 'תאריך פקיעה',
  'form.renewalDate': 'תאריך חידוש',
  'form.createdBy': 'נוצר על ידי',
  'form.updatedBy': 'עודכן על ידי',
  'form.createdAt': 'נוצר ב־',
  'form.lastUsed': 'שימוש אחרון',
  'form.updatedAt': 'עודכן ב־',
  'form.invitedAt': 'הוזמן ב־',
  'form.today': 'היום',
  'form.tomorrow': 'מחר',
  'form.days': '{{count}} ימים',
  'form.customize': 'התאם',
  'form.noExpiration': 'ללא תפוגה',
  'form.nameHelp':
    '{{type}} שלך עשוי להופיע באתר WelcomeHome היכן שאתה משתתף או מוזכר.',
  'form.type.public': 'ציבורי',
  'form.type.primary': 'ראשי',
  'form.type.draft': 'טיוטה',
  'form.type.private': 'פרטי',
  'form.type.minor': 'משני',
  'form.assets': 'נכסים ({{amount}})',
  'form.validation.min': '{{entity}} חייב להכיל לפחות {min} תווים',
  'form.metadata': 'מטא-נתונים',
  'form.section': 'חלק',
  'form.private': 'פרטי',
  'form.public': 'ציבורי',
  'form.source': 'מקור',
  'form.switch.yes': 'כן',
  'form.switch.no': 'לא',
  'form.phone.invalidPhone': 'מספר טלפון לא תקין',
  'form.phone.countryCode': 'קוד מדינה',
  'form.approve': 'אשר',
  'form.toHide': 'להסתיר',
  'form.toShow': 'להציג',
  'form.confirm': 'אישור',
  'form.name': 'שם {{entity}}',
  'form.type': 'סוג',
  'form.typeOf': 'סוג {{entity}}',
  'form.verify': 'אמת {{type}}',
  'form.enterField': 'הזן {{type}} כאן',
  'form.tag.helper': 'הוסף מילות מפתח לסיווג או זיהוי הפיצ׳ר',
  'form.metadata.helper':
    'מידע שנוצר על ידי המערכת: מי יצר או עדכן פריט זה ומתי',

  'form.credits.modal.title': 'הענקת קרדיטים',
  'form.credits.modal.ok': 'הענק',
  'form.credits.tenant': 'טנאנט',
  'form.credits.tenant.tooltip': 'הטנאנט (הארגון) שארנקו יזוכה בקרדיטים.',
  'form.credits.tenant.placeholder': 'בחר טנאנט',
  'form.credits.tenant.noTenants': 'לא נמצאו טנאנטים.',
  'form.credits.tenant.createLink': 'צור טנאנט תחילה',
  'form.credits.userId': 'מזהה משתמש',
  'form.credits.userId.tooltip':
    'המשתמש שארנקו יקבל את הקרדיטים. ברירת מחדל — ה-UID שלך. שנה כדי לזכות משתמש אחר.',
  'form.credits.userId.extra':
    'מולא מראש עם ה-UID שלך. ערוך כדי לבחור מקבל אחר.',
  'form.credits.userId.placeholder': 'Firebase UID של המקבל',
  'form.credits.amount': 'כמות',
  'form.credits.amount.tooltip':
    'מספר הקרדיטים להענקה. חייב להיות מספר שלם חיובי.',
  'form.credits.kind': 'סוג',
  'form.credits.kind.tooltip':
    'GRANT מוסיף קרדיטים; DEBIT מוריד; REFUND מחזיר קרדיטים שנוכו קודם.',
  'form.credits.kind.grant': 'GRANT — הוסף קרדיטים לארנק',
  'form.credits.kind.debit': 'DEBIT — הורד קרדיטים מהארנק',
  'form.credits.kind.refund': 'REFUND — החזר קרדיטים שנוכו',
  'form.credits.kind.adjustment': 'ADJUSTMENT — תיקון יתרה ידני',
  'form.credits.referenceId': 'מזהה ייחוס',
  'form.credits.referenceId.tooltip':
    'ייחוס חיצוני למעקב — למשל מזהה חשבונית, הזמנה או כרטיס תמיכה.',
  'form.credits.referenceId.extra':
    'השתמש בכל מזהה חיצוני (חשבונית, הזמנה, כרטיס).',
  'form.credits.referenceId.placeholder': 'למשל INV-2024-001',
  'form.credits.operation': 'פעולה',

  'form.entitlements.operation': 'פעולה',
  'form.entitlements.kind': 'סוג',
  'form.entitlements.costPerUnit': 'עלות / יחידה',
  'form.entitlements.version': 'גרסה',
  'form.entitlements.isActive': 'פעיל',

  'form.subscription.monthlyCredits': 'קרדיטים חודשיים',
};
